module.exports = __webpack_public_path__ + "img/parkinglist3.5c035239.png";